import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import EnquiryForm from '@/components/EnquiryForm';

export const useEnquiryPopup = () => {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState({ property: null, enquiryType: 'general' });

  const openEnquiry = (property = null, enquiryType = 'general') => {
    setContext({ property, enquiryType });
    setOpen(true);
  };

  const closeEnquiry = () => setOpen(false);

  return { open, openEnquiry, closeEnquiry, context };
};

const EnquiryPopup = ({ open, onClose, property = null, enquiryType = 'general' }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden" data-testid="enquiry-popup">
        <DialogHeader className="bg-[#c9a84c] text-white px-6 py-4">
          <DialogTitle className="text-lg font-bold">Submit Your Enquiry</DialogTitle>
        </DialogHeader>
        <div className="p-6">
          <EnquiryForm
            property={property}
            enquiryType={enquiryType}
            onSuccess={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EnquiryPopup;
